import { getStorage, setStorage } from "@/utils/storage";
import http from "@/utils/http";
const systemCode = process.env.VUE_APP_SYSTEM_CODE || "100016";

const state = {
  token: getStorage("tokenInfo") || "",
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
};

const actions = {
  // user login
  async getToken({ commit }) {
    try {
      const { data } = await http.request({
        url: "/user/accountlogin/tempcode",
        method: "POST",
        params: { systemCode },
      });

      const res = await http.request({
        url: "/user/accountlogin/authorizationLogin",
        method: "POST",
        params: {
          systemCode,
          tempCode: data.tempCode,
          account: "1384498742525687542",
        },
      });

      commit("SET_TOKEN", res.data);
      setStorage("tokenInfo", res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  refreshToken({ commit }, data) {
    return new Promise((resolve, reject) => {
      http
        .request({
          url: "/user/accountlogin/refreshtoken",
          method: "POST",
          params: {
            systemCode,
            refreshToken: data,
          },
        })
        .then((response) => {
          const { data } = response;
          commit("SET_TOKEN", data);
          setStorage("tokenInfo", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
